<script setup>
defineProps({
  lookup: Object
});
</script>
<template>
  <table class="w-full table-fixed">
    <thead>
      <tr>
        <th class="w-2/12 pb-3 text-left" scope="col">
          {{ $t('lookup.partials.dns.card_detail_caa.rdtype') }}
        </th>
        <th class="w-1/12 pb-3 text-left" scope="col">TTL</th>
        <th class="w-2/12 pb-3 text-left" scope="col">
          {{ $t('lookup.partials.dns.card_detail_caa.flags') }}
        </th>
        <th class="pb-3 text-left" scope="col">
          {{ $t('lookup.partials.dns.card_detail_caa.tag') }}
        </th>
        <th class="pb-3 text-left" scope="col">
          {{ $t('lookup.partials.dns.card_detail_caa.value') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(entry, i) in lookup.entries" :key="i">
        <td>CAA</td>
        <td>{{ lookup.ttl }}</td>
        <td>{{ entry.flags }}</td>
        <td>{{ entry.tag }}</td>
        <td class="break-words">
          {{ entry.value }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
